'use client'

import { AccordionPanel } from '@circlefin/components/lib/AccordionPanel'

export const CWAccordionPanel = AccordionPanel
export const CWAccordionPanelHeader = AccordionPanel.Header
export const CWAccordionPanelContent = AccordionPanel.Content
